module.exports = __webpack_public_path__ + "static/media/custmer.26829ca8.png";